import type { RefreshCart_cart_refreshCart_cart_lineItems } from '@/queries/types/RefreshCart';

import { EXTENDED_WARRANTY_SKUS } from '../_consts';

const getExistingWarranty = (
  lineItems: (RefreshCart_cart_refreshCart_cart_lineItems | null)[],
) => {
  return lineItems.find((lineItem) => {
    const sku = lineItem?.skuCode;
    if (!sku) return false;
    return EXTENDED_WARRANTY_SKUS.includes(sku);
  });
};

export default getExistingWarranty;
